// @flow

import { getComponentSettings } from './main';

import { type State } from '../reducers';

type GlobalState = {
  componentSettings: State,
};

export const getFaqSearchFieldSettings = (state: GlobalState) => {
  const faqSearchFields = getComponentSettings(state).faq_search_field;
  if (!faqSearchFields) {
    throw new Error('Missing faq_search_field settings in componentSettings store.');
  }
  return faqSearchFields;
};

export const getFaqSearchFieldButtonText = (state: GlobalState) => (
  getFaqSearchFieldSettings(state).search_button_text
);

export const getFaqSearchFieldInputPlaceholder = (state: GlobalState) => (
  getFaqSearchFieldSettings(state).search_field_placeholder
);
